import { connect } from 'react-redux';
import { subscriberConnect } from '../../../Discord/redux/actions';
const mapDispatchToProps = {
    subscriberConnect
};
export default connect(null, mapDispatchToProps);
